import { LANGUAGE_CN, LANGUAGE_EN } from '@home/_config/config';

export const LANGUAGES = [LANGUAGE_EN, LANGUAGE_CN] as const;

export type ILanguage = (typeof LANGUAGES)[number];

/**
 * 从响应体中提取文本内容
 */
export const extractTextFromResponse = async (body: unknown): Promise<string> => {
  if (typeof body === 'string') {
    return body;
  }
  if (body && typeof body === 'object' && 'text' in body && typeof body.text === 'function') {
    return body.text();
  }
  return body ? String(body) : '';
};
